<template>
    <el-dialog
            title="审核投票" class="fotoo"
            :visible.sync="dialogVisible"
            width="50%" append-to-body
            :before-close="handleClose">
        <div class="examine-body">
            <div class="no">{{submission.serialNumber}}</div>
            <el-radio-group v-model="radio" size="medium" style="margin: 20px 0">
                <el-radio :label="1" border>投票有效</el-radio>
                <el-radio :label="0" border>投票无效</el-radio>
            </el-radio-group>
            <el-input v-model="input" placeholder="请输入审核备注"></el-input>
        </div>
        <div class="flex-cm" style="padding-bottom: 40px">
            <div class="button" @click="submit">保存</div>
        </div>
    </el-dialog>
</template>
<script>
  import App from '../../util/comfun'
  export default {
    props:{
      selected:{
        type:Array,
        value:[],
      },
      submission:{
        type:Object,
        value:null,
      },
    },
    data () {
      return {
        dialogVisible: false,
        radio:'',
        input:'',
      }
    },
    methods:{
      handleClick(){},
      handleClose(done) {
        done();
      },
      show(one=null){
        this.one=one
        this.dialogVisible=true
      },
      submit(){
        if(this.radio==='' || this.input===''){
          return this.$message('请完善信息')
        }
        console.log(this.radio,this.input,this.one)
        let voteIdList=[]
        if(this.one){
          voteIdList.push(this.one.id)
        }else{
          this.selected.forEach(se=>{
            voteIdList.push(se.id)
          })
        }
        App.demand('popularVote/voteReview','POST',{
          "activityId": this.submission.activityId,
          "reviewComments": this.input,
          "reviewResult": this.radio,
          "voteIdList": voteIdList
        }).then(()=>{
          this.dialogVisible=false
          this.$emit('event',{act:'examine'})
        })
      },
    },
    mounted(){

    },

  }
</script>

<style>
    .examine-body{
        padding: 10px 60px 30px;
    }
    .button{
        width: 200px;
        height: 60px;
        opacity: 1;
        background: #3dc4a7;
        border-radius: 30px;

        opacity: 1;
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
    }
    .bg-green{
        background: #3dc4a7;
    }
    .no{
        min-width: 70px;
        height: 20px;
        background: linear-gradient(180deg,#fde6c6, #eecb9d);
        border-radius: 200px 100px 100px 0px;
        box-shadow: 0px 0px 2px 0px rgba(208,207,207,0.50);
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        color: #5d5d5d;
        position: relative;
        text-indent: 42px;
        width: 100px;
    }
    .no::before{
        background-image: url("https://assets.pfotoo.com/vote/vote%20%283%29.png");
        background-position: 10px center;
        background-repeat: no-repeat;
        background-size: 22px 10px;
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left: 0;
        content: "";
    }
</style>


// WEBPACK FOOTER //
// src/components/dialog/examine.vue